import { useState } from 'react';

const rankingItems = [
  {
    rank: 1, title: '苍穹之刃', meta: '动作 / 奇幻', heat: '9.8', tag: '热播中', tagColor: 'bg-accent-100 text-accent-700',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20dramatic%20amber%20lighting%2C%20action%20fantasy%20genre%2C%20rich%20warm%20coral%20tones%2C%20elegant%20minimal%20design%20with%20soft%20gradients%2C%20high%20quality%20textured%20background&width=200&height=240&seq=rank-01&orientation=portrait'
  },
  {
    rank: 2, title: '暗夜追光者', meta: '悬疑 / 犯罪', heat: '9.6', tag: '新上线', tagColor: 'bg-primary-100 text-primary-700',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20with%20mysterious%20dark%20mood%2C%20crime%20thriller%20genre%2C%20warm%20golden%20accent%20lighting%2C%20artistic%20composition%20with%20soft%20gradients%2C%20high%20quality%20textured%20background&width=200&height=240&seq=rank-02&orientation=portrait'
  },
  {
    rank: 3, title: '浮生若梦记', meta: '古装 / 爱情', heat: '9.5', tag: '热播中', tagColor: 'bg-accent-100 text-accent-700',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20with%20romantic%20historical%20aesthetic%2C%20costume%20drama%20genre%2C%20soft%20coral%20and%20amber%20tones%2C%20elegant%20composition%20with%20silk%20textures%2C%20high%20quality%20background&width=200&height=240&seq=rank-03&orientation=portrait'
  },
  {
    rank: 4, title: '极境生存', meta: '纪录 / 冒险', heat: '9.3', tag: '高分', tagColor: 'bg-secondary-100 text-secondary-700',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20with%20documentary%20adventure%20vibe%2C%20warm%20earthy%20tones%2C%20vast%20landscape%20aesthetic%2C%20artistic%20minimal%20design%20with%20soft%20gradients%2C%20high%20quality%20textured%20background&width=200&height=240&seq=rank-04&orientation=portrait'
  },
  {
    rank: 5, title: '长安十二时辰', meta: '历史 / 悬疑', heat: '9.2', tag: '经典', tagColor: 'bg-secondary-100 text-secondary-700',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20with%20ancient%20Chinese%20city%20aesthetic%2C%20historical%20mystery%20genre%2C%20warm%20amber%20lantern%20lighting%2C%20elegant%20composition%20with%20rich%20textures%2C%20high%20quality%20background&width=200&height=240&seq=rank-05&orientation=portrait'
  },
  {
    rank: 6, title: '时空缉凶', meta: '科幻 / 推理', heat: '9.0', tag: '新上线', tagColor: 'bg-primary-100 text-primary-700',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20with%20sci-fi%20mystery%20vibe%2C%20futuristic%20crime%20genre%2C%20warm%20coral%20and%20golden%20glow%2C%20artistic%20minimal%20design%20with%20soft%20gradients%2C%20high%20quality%20textured%20background&width=200&height=240&seq=rank-06&orientation=portrait'
  },
];

export default function Ranking() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">全网观众正在追的热门影视，实时热度排行一目了然</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative shrink-0 w-16 h-20 md:w-20 md:h-24 rounded-lg overflow-hidden bg-background-200">
                {!imgErrors[item.rank] ? (
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    onError={() => setImgErrors((prev) => ({ ...prev, [item.rank]: true }))}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="ri-movie-line text-xl text-foreground-300"></i>
                  </div>
                )}
                <div className="absolute top-1 left-1 w-5 h-5 rounded-md bg-foreground-900/70 flex items-center justify-center">
                  <span className="text-xs font-bold text-background-50">{item.rank}</span>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-base text-foreground-900 truncate">{item.title}</h3>
                  <span className={`shrink-0 text-[10px] px-1.5 py-0.5 rounded-full ${item.tagColor} whitespace-nowrap`}>{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mb-1.5">{item.meta}</p>
                <div className="flex items-center gap-1 text-xs text-primary-600">
                  <i className="ri-fire-line"></i>
                  <span className="font-medium">{item.heat}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}